import axios from "axios";
import Cookies from "js-cookie";
// const url = 'https://api.voltcapital.ua/api/admin';
const url = process.env.REACT_APP_API_ENDPOINT;

const axiosFunc = async (method, link, body, params = {}) => {
  try {
    const res = await axios({
      method: method,
      baseURL: url,
      url: link,
      params: params,
      data: body,
      headers: {
        authorization: "Bearer " + Cookies.get("adminToken"),
        Accept: "application/json",
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "any",
      },
    });
    return res.data;
  } catch (err) {
    console.log("Error:::", err);
    return err;
  }
};

export default axiosFunc;
